import type { LinkProps } from "ui/components/Link";
import Link from "ui/components/Link";
import cx from "ui/cx";
import styles from "./TabbedMenu.module.scss";

export type TabbedMenuItem = {
  text?: string;
  selected: boolean;
  path?: string;
  hidden?: boolean;
} & LinkProps;

interface TabbedMenuProps {
  menuItems: TabbedMenuItem[] | undefined;
  className?: string;
}

export default function TabbedMenu({ menuItems, className }: TabbedMenuProps) {
  return (
    <div className={cx(styles.wrapper, className)} data-testid="tabbed-menu">
      {menuItems &&
        menuItems
          .filter((m) => !m.hidden)
          .map(({ text, path, selected, ...props }, i) => {
            return (
              <Link
                key={i}
                href={path}
                selected={selected}
                selectedCx="selected"
                {...props}
                aria-label={`Select ${text} tab`}
              >
                {text}
              </Link>
            );
          })}
    </div>
  );
}
